/**
 * Builds a sort string based on the provided sort object.
 *
 * The function converts the `direction` property of the sort object
 * from "ascending" or "descending" to "asc" or "desc", respectively.
 * It also maps the `field` property to its corresponding database field name.
 *
 * @param sort - An object containing the sort configuration.
 * @param sort.direction - The direction of sorting, either "ascending" or "descending".
 * @param sort.field - The field to sort by, which can be one of the following:
 *   - "name": Maps to "name".
 *   - "type": Maps to "type".
 *   - "lastUpdated": Maps to "last_updated".
 * @returns A string representing the sort configuration in the format: `<field> <direction>`.
 */
export const buildSort = (sort) => {
    let direction = sort.direction;
    if (direction === "ascending") {
        direction = "asc";
    }
    else if (direction === "descending") {
        direction = "desc";
    }
    let field = sort.field;
    const fieldMap = {
        name: "name",
        type: "type",
        lastUpdated: "last_updated"
    };
    field = fieldMap[field] ?? field;
    return `${field} ${direction}`;
};
/**
 * Converts a sort object into a query parameter string for use in HTTP requests.
 *
 * @param sort - An object representing the sorting configuration, which includes
 *               the field to sort by and the direction of sorting (ascending or descending).
 *               If undefined or missing required properties, an empty string is returned.
 * @returns A query parameter string in the format `&sortBy=<field>:<direction>`,
 *          or an empty string if the input is invalid.
 */
export const sortToQueryParam = (sort) => {
    if (sort && sort.field && sort.direction) {
        return `&sortBy=${buildSort(sort)}`;
    }
    return "";
};
//# sourceMappingURL=sort.js.map